<template>
    <div>
        <PageHeader :page="page" :template="'2'" @action="createNew"  v-if="!state.loading"/>
        <div class="content" v-if="!state.loading">
            <DataTable :tableData="tableData" @view="view" @edit="edit"
                @deposit="deposit" @deposit_history="depositHistory"/>
        </div>
        <div class="temp-row" v-if="state.loading" style="text-align: center;">
          <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </div>

    <ModalView
        :isVisible="state.CreateModal"
        :fixclose="true"
        @close="state.CreateModal = false">
        
        <DynamicForm :columns="1"
        :fields="newFields" @submit="addTransaction"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" />
    </ModalView> 
</template>
<script>
import icons from '@/assets/js/icons.js';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { ref, reactive, onMounted, computed } from 'vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls";
import DataTable from '@/components/DataTable.vue';
import PageHeader from '@/components/PageHeader.vue';
import DynamicForm from '@/components/DynamicForm.vue';
import ModalView from '@/components/ModalView.vue';
import { usePermissions } from '@/composables/usePermissions';
export default{
    components:{PageHeader, DataTable,DynamicForm,ModalView},
    setup(){
        const { hasPermission } = usePermissions();
        const store= useStore();
        const system = computed(() => store.state.System.system);
        const router = useRouter();
        const accounts=ref([]);
        const state=reactive({CreateModal:false, submitting:false,error:[],success:false,loading:true});
        const page=ref({title:"All Invoice", btn:"Create New",
        desc:"Manage all invoice in one page"})
        const newFields=ref([])
        if(!hasPermission('Invoice', 'create')){
            page.value.btn="";
        }

        const tableData = ref({
            rows: [],
            loading: true,
            columns: [
                { label: "No" },
                { label: "Client" },
                { label: "Dates" },
                { label: "Items" },
                { label: "Amount" }
            ],
            options:{
                label:"Options",
                action_label:[icons.view,icons.edit,icons.transactions,icons.skills],
                action:["view","edit","deposit","deposit_history"]
            },
            total:0
        });

        if(!hasPermission('Invoice', 'edit')){
            tableData.value.options.action_label.splice(1,1)
            tableData.value.options.action.splice(1,1)
        }

        onMounted(()=>{
            call({
                url:urls.transactions,
                data:{getInvoiceList:""},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        var d=res.msg;
                        accounts.value=[];
                        Object.keys(d.accounts).forEach(k => {
                            accounts.value.push(d.accounts[k])
                        })
                        setTable(d.list);
                    }else{
                        alert(res.msg);
                    }
                }
            })
        })

        function setTable(msg){
            var data={}
            tableData.value.loading = false;
            tableData.value.rows.length=0
            Object.keys(msg).forEach(set => {
                data={id:msg[set].id,status:msg[set].status};
                var v=[];
                Object.keys(msg[set].val).forEach(row => {
                v.push(msg[set].val[row])
                });
                data.val=v;
                tableData.value.rows.push(data)
            });
            tableData.value.total=tableData.value.rows.length
        }

        function view(i){
            var id=tableData.value.rows[i].id
            router.push({ name: 'viewinvoice', params: { id: id } });
        }

        function setErrors(res){
            var errors=[];
            Object.keys(res.msg).forEach(key => {
                var e=res.msg[key],er="";
                Object.keys(e).forEach(k => {
                er+=er=="" ? e[k] : ", "+e[k]
                })
                errors.push(er);
            });
            state.errors=errors;
        }

        function deposit(i){
            var id=tableData.value.rows[i].id
            newFields.value.length=0;
            newFields.value.push(
                { name: "Add Deposit", number: "1",data: 
                    [
                        { type: 'select', name: 'account', label: 'Account',
                            value: "", options:accounts},
                        { type: 'text', name: 'amount', label: 'Amount',
                        value: ""  },
                        { type: 'select', name: 'type', label: 'Type',
                            value: "", options:[{label:"Credit",value:"credit"}]},
                        { type: 'date', name: 'date', label: 'Transaction Date',
                            value: ""},
                        { type: 'textarea', name: 'note', label: 'Note',
                            value: ""  },
                        { type: 'hidden', name: 'invoice_id',
                        value: id }
                    ]
                }
            )

            if(system.value.acct_type == "simple"){
                newFields.value.length=0;
                newFields.value.push(
                    { name: "Add Deposit", number: "1",
                    data: 
                        [
                            { type: 'text', name: 'amount', label: 'Amount',
                            value: ""  },
                            { type: 'select', name: 'type', label: 'Type',
                                value: "", options:[{label:"Income",value:"credit"},{label:"Expense",value:"debit"}]},
                            { type: 'date', name: 'date', label: 'Transaction Date',
                                value: ""},
                            { type: 'textarea', name: 'note', label: 'Note',
                                value: ""  },
                            { type: 'hidden', name: 'invoice_id', value: id }
                        ]
                    }
                )
            }
            state.CreateModal=true;
            state.submitting=false;
            state.errors=[]
            state.success=false;
        }

        function addTransaction(data){
            state.submitting=true;
            state.errors=[];
            data.addInvoiceDeposit="";
            call({
                url:urls.transactions,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg)
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function depositHistory(i){
            var id=tableData.value.rows[i].id
            router.push({ name: 'invoicehistory', params: { id: id } });
        }

        function createNew(){
            router.push({ name: 'createinvoice' });
        }

        function edit(i){
            var id=tableData.value.rows[i].id
            router.push({ name: 'editinvoice', params: { id: id } });
        }

        return {page,tableData,state, view,deposit,newFields,edit,
            addTransaction,depositHistory,createNew}
    }
}

</script>